import React from 'react'
import { Button } from '~components/Button'
import { ColorType } from '~components/Button/Button.types'
import Modal, { ModalProps } from './Modal'
import * as StyledModal from './Modal.styles'

export interface ComponentProps extends ModalProps {
  /**
   * Inner text
   */
  text?: React.ReactNode | string
  /**
   * Label for cancel button
   */
  cancelLabel?: string
  /**
   * Label for confirm button
   */
  confirmLabel?: string
  /**
   * Color of confirm button, defaults to `danger`
   */
  confirmButtonColor?: ColorType
  /**
   * Has disabled state?
   */
  isDisabled?: boolean
  /**
   * Has loading state?
   */
  isLoading?: boolean
  /**
   * Action on confirm
   */
  onConfirm: () => void
}

const ConfirmationModal: React.FC<ComponentProps> = ({
  text,
  onClose,
  onConfirm,
  cancelLabel = 'Cancel',
  confirmLabel = 'Confirm',
  confirmButtonColor = 'danger',
  isLoading,
  isDisabled,
  ...modalProps
}) => {
  const titleOverride = text ? undefined : 'Are you sure?'

  return (
    <Modal onClose={onClose} title={titleOverride} {...modalProps}>
      {text && <StyledModal.MediumBody spaceForClose={!modalProps.title && !titleOverride}>{text}</StyledModal.MediumBody>}
      <StyledModal.Footer>
        <Button size="small" onClick={onClose} color="base" variant="outlined">
          {cancelLabel}
        </Button>
        <Button size="small" onClick={onConfirm} color={confirmButtonColor} isLoading={isLoading} disabled={isDisabled}>
          {confirmLabel}
        </Button>
      </StyledModal.Footer>
    </Modal>
  )
}

export default ConfirmationModal
